import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="relative border-t border-white/5 bg-xp-bg" data-testid="site-footer">
      <div className="container-xp py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 space-y-6">
          <Logo />
          <p className="text-xp-muted text-sm max-w-sm">
            <span className="brand">Xpace</span> is a specialist enterprise ERP consultancy. We architect, implement and run SAP S/4HANA &amp; BRIM,
            Oracle Fusion Cloud ERP and Salesforce Revenue Cloud — with deep Order-to-Cash expertise.
          </p>
          <div className="space-y-2 text-sm text-xp-muted">
            <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-xp-cyan" /> HR@xpace.work</div>
            <div className="flex items-start gap-2"><MapPin className="h-4 w-4 text-xp-cyan mt-0.5" />
              <span>
                <span className="text-xp-text">USA</span> · 1401 21st St, Ste R, Sacramento, CA 95811
              </span>
            </div>
            <div className="flex items-start gap-2"><MapPin className="h-4 w-4 text-xp-cyan mt-0.5" />
              <span>
                <span className="text-xp-text">India</span> · Ste 8, Sushie Eden Garden, Kokapet, Hyderabad 500075
              </span>
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-4">Navigate</div>
          <ul className="space-y-2 text-sm">
            {[
              ["Home", "/"],
              ["Services", "/services"],
              ["Solutions", "/solutions"],
              ["Case Studies", "/case-studies"],
              ["Contact", "/contact"],
            ].map(([label, href]) => (
              <li key={href}>
                <Link to={href} className="text-xp-muted hover:text-xp-text link-reset transition-colors">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="eyebrow mb-4">Focus Areas</div>
          <ul className="space-y-2 text-sm text-xp-muted">
            <li>SAP BRIM — SOM, CC, CI, FI-CA</li>
            <li>Oracle — CPQ, Subscription, RMCS</li>
            <li>Salesforce — Revenue Cloud (CPQ + Billing)</li>
            <li>Integration — MuleSoft, OIC, SAP BTP</li>
            <li>OTC Staffing — on-demand specialists</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="container-xp py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-xp-dim">
          <div className="font-mono"><span className="brand">Xpace</span> — all rights reserved</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
